import IBAN from 'iban'

import Rule from './Rule'

export default class Iban extends Rule {
  get ruleName () {
    return 'iban'
  }

  passes () {
    return IBAN.isValid(this.value)
  }
}
